<template>
  <div class="service-work">
    <main-header></main-header>

    <div class="service-work--container">
      <div>
        <div style="font-size: 48px; color: #333;">
          <f-awesome icon="cog"></f-awesome>
        </div>
        <h3>
          В данный момент мы ставим важные обновления, поэтому сервис недоступен.<br><br>
          Обычно, это занимает 3 - 10 минут. Пожалуйста, повторите попытку немного позже.
        </h3>
      </div>

      <div style="margin-top: 20px;">
        <router-link class="btn btn-sm btn-outline-info" tag="a" :to="`/`"
        >На главную</router-link>
      </div>
    </div>

    <main-footer></main-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import MainHeader from "../components/site/MainHeader";
import MainFooter from "../components/site/MainFooter";

export default {
  name: "ServiceWork",
  components: {
    MainFooter,
    MainHeader
  },
  data() {
    return {

    };
  },
  computed: {

  },
  methods: {

  },
  created() {

  }
};
</script>

<style scoped lang="less">
.service-work--container {
  width: 500px;
  min-height: 65vh;
  padding-top: 70px;
  margin: 0 auto 60px auto;
  text-align: center;
}

@media (max-width: 700px) {
  .service-work--container {
    width: 98%;
  }
}
</style>
